<template>
  <div class="infographics">
  <b-overlay :show="this.expiredTrial" rounded="sm" no-center>

    <Error></Error>
    <InfoGraphicsComponent></InfoGraphicsComponent>

    <template #overlay>
      <div class="text-center">
        <b-icon icon="lock" font-scale="3" animation="cylon" class="mb-3 mt-5"></b-icon>
        <h2 id="cancel-label">Your trial account has expired. <br>Register for a <a href="https://www.sci-fund.ai/plans-and-prices" target="_blank">full membership</a> or <a href="mailto:info@sci-fund.ai?subject=sci-fund%20Account">get in touch</a>.</h2>

      </div>
    </template>
  </b-overlay>
  </div>
</template>

<script>
  import InfoGraphicsComponent from '@/components/InfoGraphicsComponent'
  import Error from '@/components/Error'

  export default {
    name: 'InfoGraphics',
    components: {
      Error,
      InfoGraphicsComponent
    },
    computed: {
      expiredTrial() {
        if (this.$store.state ) {
          return this.$store.state.expiredTrial;
        }
        return false;
      },

    }
  }
</script>


<style type="scss">

</style>
